import { useEffect } from "react";
import Commodity from '../table/Tablestandardize';
import Modal from "../modal/Modaladdcommodity"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    {/* <Modal/> */}
    <Commodity/>
    
     
     </>
  );
};

export default Dashboard;
